import { Box, Typography } from "@mui/material";
import { NotificationFullData } from "../../layout/UserNotification";
import React from "react";
import useThemeStore from "../../services/store/useThemeStore";
import { wrapperStyles } from "./BookingStarted";
import { contentStyles } from "./BookingStarted";
import { titleStyles } from "./BookingStarted";
import { DateNTime } from "../../utils/dateTime";
import { useNavigate } from "react-router-dom";

const FlashCardBookingNotification = ({
  notification,
}: {
  notification: NotificationFullData;
}) => {
  const { darkMode } = useThemeStore();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/flash-bookings`);
  };
  return (
    <Box
      onClick={handleClick}
      sx={{ ...wrapperStyles(darkMode), cursor: "pointer" }}
    >
      <Box sx={{ ...contentStyles, cursor: "pointer" }}>
        <Typography sx={titleStyles(darkMode)}>Flash Card Booking</Typography>
        <Typography
          sx={{
            color: darkMode ? "#e5e7eb" : "#374151",
            font: "var(--body-xs)",
            fontWeight: 400,
          }}
        >
          {notification.message}
        </Typography>
        {notification?.created_at && (
          <Typography
            sx={{
              font: "var(--semibold-xxs)",
              color: darkMode ? "#9ca3af" : "#64748b",
              fontWeight: 500,
            }}
          >
            {DateNTime.formatRelative(notification.created_at)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default FlashCardBookingNotification;
